import React, { useState } from "react";
import { Modal, Button, Form, Input } from "antd";
import { Link } from "react-router-dom";

// ICONS
import { FaFacebookF, FaGoogle } from "react-icons/fa";

export default function Signin() {
    const [modalVisible, setModalVisible] = useState(false);

    const handleModalVisible = (modalVisible) => {
        setModalVisible(modalVisible);
    };

    const onFinish = (values) => {
        console.log("Success:", values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <>
            <Button type="button" onClick={() => handleModalVisible(true)}>
                SIGNIN
            </Button>
            <Modal
                centered
                visible={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                footer={null}
            >
                <div className="log_wrapper">
                    <div className="signin">
                        <h1>Sign in</h1>
                        <div className="social_media">
                            <div>
                                <FaFacebookF />
                            </div>
                            <div>
                                <FaGoogle />
                            </div>
                        </div>
                        <p>or use your account</p>
                        <Form
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your email!",
                                    },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter your password!",
                                    },
                                ]}
                            >
                                <Input.Password placeholder="Enter your password" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Sign In
                                </Button>
                            </Form.Item>
                            <div className="forgotPassword">
                                <Link to={"/"}>Forgot your password?</Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </Modal>
        </>
    );
}
